import { Text, StyleSheet, View } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    titleContainer: {
        flexDirection: 'row',
        marginTop: 24,
        fontSize: 9,
        lineHeight: 1.5
    },
    noteContainer: {
        flexDirection: 'row',
        marginTop: 10,
        fontSize: 9,
        lineHeight: 1.5
    },
    footerNote: {
        flexDirection: 'row',
        marginTop: 10,
        fontSize: 9,
        lineHeight: 1.5,
        fontFamily: 'Helvetica-Bold'
    }
});

interface Props {
    isYearPartialyCompleted: boolean;
}

const ReceiptFooter = ({ isYearPartialyCompleted }: Props) => {
    return <>
        {isYearPartialyCompleted === true && <View style={styles.titleContainer}>
            <Text>
                * Partial Year Completed.
            </Text>
        </View>}

        <View style={styles.noteContainer}>
            <Text>
                Note: CPD Category requirements are displayed in brackets.
            </Text>
        </View>

        <View style={styles.footerNote}>
            <Text>
                Please note: (Req.) = Required  - (Not Req.) =  Not Required.
            </Text>
        </View>
    </>
}

export default ReceiptFooter;